import React from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';

export default function({ onClick }) {
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const user = useSelector(state => state.AppState.user);
  const getActivateButtonText = () => {
    if (!boxDetails) return '';
    const { everythingOnline, registerationCreated } = boxDetails;
    if (everythingOnline && registerationCreated) return 'Edge Device Activated';
    if (!everythingOnline && registerationCreated) return 'Pending Activation';
    return 'Activate box';
  };
  const getColor = () => {
    const { everythingOnline, registerationCreated } = boxDetails;
    if (everythingOnline && registerationCreated) return 'success';
    return 'primary';
  };
  const getIsDisabled = () => {
    const { everythingOnline, registerationCreated } = boxDetails;
    if (everythingOnline && registerationCreated && user.role !== 'superAdmin') return true;
    return false;
  };
  const onButtonPress = () => {
    const { datacenter } = boxDetails;
    if (datacenter != 'la') {
      return toast.success('Please move to LA Data Center to enable this feature.');
    }
    onClick();
  };
  return (
    <Button
      className="activate-btn"
      disabled={getIsDisabled()}
      color={getColor()}
      onClick={onButtonPress}
    >
      {getActivateButtonText()}
    </Button>
  );
}
